import type { QueryFunctionContext } from '@tanstack/react-query';
import { queryOptions } from '@tanstack/react-query';
import { apiClient } from 'lib/api';
import type { PageOptionsDTO } from './types';
import type { AdsLibraryApiPathParams } from './parseAdsLibraryApiPath';
import { parseAdsLibraryApiPath } from './parseAdsLibraryApiPath';

export const getAdPages = async ({
  signal,
  queryKey,
}: QueryFunctionContext<[string, string]>): Promise<PageOptionsDTO[]> => {
  const res = await apiClient.get<{ data: PageOptionsDTO[] }>(queryKey[1], {
    signal,
  });
  return res.data.data;
};

export const getAdPagesOptions = (params: AdsLibraryApiPathParams = {}) =>
  queryOptions({
    staleTime: 60 * 60 * 1000,
    queryFn: getAdPages,
    queryKey: ['ad-pages', parseAdsLibraryApiPath('ad_pages', params)] as const,
  });
